import EditUserRolePermissionDialog from './EditUserRolePermissionDialog';

export default EditUserRolePermissionDialog;